import { render, staticRenderFns } from "./view-config.vue?vue&type=template&id=36c0ecdf&scoped=true"
import script from "./view-config.vue?vue&type=script&lang=js"
export * from "./view-config.vue?vue&type=script&lang=js"
import style0 from "./view-config.vue?vue&type=style&index=0&id=36c0ecdf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c0ecdf",
  null
  
)

export default component.exports